import React, { PropsWithChildren, StrictMode } from 'react';

import { Provider } from 'react-redux';

import { PersistGate } from 'redux-persist/integration/react';

import { StaticLoader } from '@hsp/react-component-library';

import { persistor, store } from 'store/index';

const ReduxRoot: React.FC<PropsWithChildren> = ({ children }) => {
  return (
    <StrictMode>
      <Provider store={store}>
        <PersistGate
          loading={<StaticLoader />}
          persistor={persistor}>
          {children}
        </PersistGate>
      </Provider>
    </StrictMode>
  );
};

export default ReduxRoot;
